import { render, staticRenderFns } from "./move-measures-modal.vue?vue&type=template&id=28178759&scoped=true"
import script from "./move-measures-modal.vue?vue&type=script&lang=js"
export * from "./move-measures-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28178759",
  null
  
)

export default component.exports